import { Box } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export const FooterCpdDetail = withTheme(styled(Box)`
  background: linear-gradient(92.76deg, #538d87 24.56%, #164843 93.61%);
  color: white;
  position: ${(props: any) => (props.isSticky ? 'sticky' : 'relative')};
  bottom: 0;
  width: 100%;
  height: 160px;

  ${(props: any) => props.theme.breakpoints.down('md')} {
    height: 80px;
  }
`);

export const CanNotTrainBox = withTheme(styled(Box)`
  background: rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  color: white;
  width: 100%;
  height: ${(props: any) => props.height || '100%'};
  padding: ${(props: any) => props.padding || '14px'};

  .cannot-train-icon {
    width: 22px;
    height: 22px;
    font-size: 22px;
    position: relative;
    top: -2;
  }
`);
